import { TailSpin } from 'react-loader-spinner';

const Loader = (): JSX.Element => {
  return (
    <TailSpin
      color="rgb(var(--ink))"
      height={35}
      width={35}
      visible
      ariaLabel="tail-spin-loading"
      radius="1"
      wrapperStyle={{}}
      wrapperClass=""
    />
  );
};

export default Loader;
